import { createMqStyles, tokens } from '@fhs/ui';

/** Panel width from the desktop split-pane design: 488 of content plus a 12 scrollbar gutter. */
export const DESKTOP_PANEL_WIDTH = 500;

/** Fixed map band above the list on mobile and native. */
export const STACKED_MAP_HEIGHT = 250;

export const useStoreLocatorV2MqStyles = createMqStyles({
  root: {
    $base: {
      backgroundColor: tokens.colors.$white,
      flex: 1,
    },
    $gteDesktop: {
      flexDirection: 'row',
    },
  },
  /**
   * Mobile web stacks the site footer under the locator. The footer is taller than the viewport,
   * so as a plain flex sibling it shrinks the locator to nothing. Refusing to shrink — paired
   * with the viewport min-height applied in the view — keeps the map and list at full height and
   * leaves the footer where it belongs, one scroll below.
   */
  rootWithFooter: {
    $base: {
      flexShrink: 0,
    },
  },
  panel: {
    $base: {
      backgroundColor: tokens.colors.$white,
      flex: 1,
    },
    $gteDesktop: {
      borderRightColor: tokens.colors.$black10,
      borderRightWidth: 1,
      flex: 0,
      flexBasis: DESKTOP_PANEL_WIDTH,
      flexGrow: 0,
      flexShrink: 0,
      width: DESKTOP_PANEL_WIDTH,
    },
  },
  panelControls: {
    $base: {
      gap: 12,
      paddingHorizontal: 16,
      paddingBottom: 8,
      // Suggestions are absolutely positioned and overflow this block, so it has to
      // stack above the tabs and store list that follow it in the DOM.
      zIndex: 1,
    },
    $gteDesktop: {
      gap: 24,
      paddingHorizontal: 32,
      paddingBottom: 24,
    },
  },
  // Desktop fills the pane; smaller screens get a fixed band above the tabs. Both sides are
  // declared under mutually exclusive queries rather than overriding a `$base` flex, because the
  // resolved styles are merged and a leftover `flexBasis: 0%` would collapse the fixed height.
  mapPane: {
    $ltDesktop: {
      height: STACKED_MAP_HEIGHT,
    },
    $gteDesktop: {
      flex: 1,
    },
  },
  listArea: {
    $base: {
      flex: 1,
    },
  },
  /**
   * The shared bottom sheet sizes to its content up to 90% of the screen. Details needs a
   * definite height so its own scroll view can fill the sheet and the map stays visible above it.
   */
  detailsSheet: {
    $base: {
      height: '85%',
      overflow: 'hidden',
    },
  },
  detailsSheetBody: {
    $base: {
      flex: 1,
    },
  },
});
